export default "__VITE_PUBLIC_ASSET__40fc4fdb__"